import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef} from '@angular/core';
import { PersonService } from '../../services/person.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RepurchaseService } from '../../../repurchase/services/repurchase.service';

import * as moment from 'moment/moment';

@Component(
  {
  selector: 'app-person',
  templateUrl: './person.component.html',
  styleUrls: ['./person.component.css'],
  providers: [PersonService,RepurchaseService]
})




export class PersonComponent implements OnInit {
  @Output() personSelected = new EventEmitter();
  person: any = {}; 
  webcam: any;//will be populated by ack-webcam [(ref)]
  media:any;
  showCamera: any = false;
  expirationDateToast:any;
  bornDateToast:any;
  config: any = {'sourceField': ['name']};
  towns: any = [
    {name:"Santa Cruz de Tenerife"}
  ];
  states: any = [
    {name:"Santa Cruz de Tenerife"}
  ];
  constructor(private personService: PersonService,public toastr: ToastsManager, vcr: ViewContainerRef, private router: Router, private repurchaseService:RepurchaseService) { 
    this.toastr.setRootViewContainerRef(vcr);
  }


  ngOnInit() {
  }

  townSelected(e){
    this.person.town = e.name
  }
  stateSelected(e){
    this.person.state = e.name
  }

  returnProperties(person){
    var properties = {
      nif: person.nif,
      name: person.name,
      surname: person.surname,
      nif_expiration_date: person.nif_expiration_date,
      born_date: person.born_date,
      address: person.address,
      cp: person.cp,
      town: person.town,
      state: person.state,
      telephone: person.telephone,
      mobile: person.mobile,
      email: person.email,
      warning: person.warning
    }
    if (person.id){
      properties['id'] = person.id;
    }
    return properties;
  }


  search(nif){
    this.person = {};
    let params={
      nif: nif
    }
    this.personService.query(params)
    .subscribe((people) => {
      if (people[0] === undefined){
        this.person.nif = nif;
      }else{
        var person = people[0];
        person.born_date = this.getDate(person.born_date);
        person.nif_expiration_date = this.getDate(person.nif_expiration_date);
        this.person = person;
        if (this.person.warning != null && this.person.warning != ""){
          this.toastr.warning(this.person.warning, '¡Alerta!', {dismiss: "controlled",showCloseButton:true});
        }
        if (moment(this.person.nif_expiration_date).isBefore(moment())){
          this.toastr.warning('DNI caducado', '¡Fecha de caducidad del DNI!', {dismiss: "controlled",showCloseButton:true});
        }
        this.repurchaseService.query({
          where:{
            person_id: person.id,
            observations: { '!' : "" }
          }
        })
        .subscribe((repurchases) => {
          let message = "";
          repurchases.forEach((r)=>{
            if (r.observations){
              message += r.observations + ". ";
            }
          });
          if (message != null && message != ""){
            this.toastr.warning(message, '¡Alerta!', {dismiss: "controlled",showCloseButton:true});
          }
        });
      }
    });
  }
    

  save(){
    if (this.person.id == undefined){
      this.personService.create(this.returnProperties(this.person))
      .subscribe((person) => {
        person.born_date = this.getDate(person.born_date);
        person.nif_expiration_date = this.getDate(person.nif_expiration_date);
        this.person = person;
      });
    }else{
      this.personService.update(this.returnProperties(this.person))
      .subscribe((person) => {
        person.born_date = this.getDate(person.born_date);
        person.nif_expiration_date = this.getDate(person.nif_expiration_date);
        this.person = person;
      });
    }
  }

  selectUser(event){
    if (this.person.id != undefined  ){
      this.personSelected.emit(this.person);}
      
  }
 

  checkNifExpirationDate(){
    if(this.expirationDateToast){this.toastr.dismissToast(this.expirationDateToast);}
    if (moment(this.person.nif_expiration_date).isBefore(moment())){
      this.toastr.warning('La fecha proporcionada es anterior a hoy', '¡Fecha de caducidad del DNI!', {dismiss: "controlled",showCloseButton:true}).then((toast)=>{this.expirationDateToast = toast;});
    }
  }

  checkBornDate(){
    if(this.bornDateToast){this.toastr.dismissToast(this.bornDateToast);}
    if (moment().diff(moment(this.person.born_date), 'years') < 18){
      this.toastr.warning('Menor de 18 años', '¡Fecha de nacimiento!', {dismiss: "controlled",showCloseButton:true}).then((toast)=>{this.bornDateToast = toast;});
    }
  }

  getDate(date){
    if (date){
      date = new Date(date);
      let month = (date.getMonth()+1) < 10? '0'+(date.getMonth()+1):(date.getMonth()+1);
      let day = date.getDate() < 10? '0'+date.getDate():date.getDate();
      return date.getFullYear() + "-" + month + '-' + day;
    }else{
      return null;
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/person/components/person/person.component.ts